<template>
  <BeerButton
    :disabled="disabled"
    :bs="myBs"
    :size="size"
    :variant="variant"
    @click="onInput"
  >
    <!-- @slot 自定义标签 -->
    <slot :label="label">
      {{ label }}
    </slot>
  </BeerButton>
</template>

<script lang="ts">
  import { PropType, defineComponent, computed } from 'vue'
  import { isUndefined } from 'lodash'
  import BeerButton from '@xhs/yam-beer/cmp/common/Button/Button.vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import {
    injectOptionsContext,
  } from '@xhs/yam-beer/compose/options/useOptions'
  import initStyle from './style'

  initStyle()

  export default defineComponent({
    name: 'RadioButton',
    components: {
      BeerButton,
    },
    props: {
      /**
       * @ignore
       * 覆盖 wrapper inline 的样式
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 标签名称
       */
      label: String,
      /**
       * Radio 选中的 value
       */
      value: {
        type: [String, Number, Boolean, Object],
        default: false,
      },
      /**
       * 受控的值
       */
      modelValue: {},
      /**
       * 是否初始选中，多用于纯样式展示
       * @type {true|false}
       * @see style
       */
      checked: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否禁用
       */
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const [context, isFallback] = injectOptionsContext(
        'radiogroup',
        props.value,
        props.modelValue,
      )
      const modelValue = computed(() => {
        if (isFallback) {
          return props.modelValue
        }
        return context.modelValue.value
      })

      const isChecked = computed(() => {
        if (isUndefined(modelValue.value)) {
          return props.checked
        }
        if (!isFallback) {
          return context.valueToItem(modelValue.value).id === context.valueToItem(props.value).id
        }
        return modelValue.value === props.value
      })

      const onInput = () => {
        emit('update:modelValue', props.value)
        if (!isFallback) {
          context.onChange(context.valueToItem(props.value))
        }
      }
      return {
        isChecked,
        size: context.size,
        myBs: computed(() => {
          const bs = {
            mr: -1,
            zIndex: isChecked.value ? 2 : 1,
            borderRadius: 0,
            '&:first-of-type': {
              borderTopLeftRadius: 'control',
              borderBottomLeftRadius: 'control',
            },
            '&:last-of-type': {
              borderTopRightRadius: 'control',
              borderBottomRightRadius: 'control',
            },
            ...props.bs,
          }
          if (props.disabled) {
            bs.zIndex = 0
          } else {
            // @ts-ignore
            bs['&:hover'] = {
              zIndex: 3,
            }
          }
          return bs
        }),
        variant: computed(() => {
          if (!isChecked.value) {
            return 'secondary'
          }
          if (context.buttonStyle === 'fill') {
            return 'default'
          }
          return 'outline'
        }),
        onInput,
      }
    },
  })
</script>
